import React from 'react';
import './avatar.css';

export const Avatar = ({ children, size = 'medium', image, className = '' }) => {
  const sizeClasses = {
    'x-large': 'w-16 h-16 text-2xl',
    'large': 'w-12 h-12 text-xl',
    'medium': 'w-10 h-10 text-base',
    'small': 'w-8 h-8 text-sm',
    'x-small': 'w-6 h-6 text-xs'
  };

  return (
    <div className={`avatar ${sizeClasses[size]} ${className}`}>
      {image ? (
        <img src={image} alt="Avatar" className="avatar-image" />
      ) : (
        <span className="avatar-initials">{children}</span>
      )}
    </div>
  );
}; 